import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class ListItem extends Component {
    // Route props
    static propTypes = {
        location: PropTypes.object.isRequired
    };

    render = () => {

        let url = this.props.url; 
        
        if(this.props.root_url){
            url = '/' + url;
        }else{
            url = '/settings/' + url;
        }

        return (
            <li>
                <Link to={url}>
                    <h3>{this.props.label}</h3>
                    <img src="assets/images/settings/chevron.svg" alt="" />
                    <div className={this.getClassName()} />
                </Link>
            </li>
        );
    };

    getClassName() {
        var classNames = 'menu-marker menu-marker';
        if (this.isActive()) {
            classNames += '-active';
        } else {
            classNames += '-inactive';
        }

        return classNames;
    }

    // Check if menu item is active depending on present route
    isActive() {
        const { location } = this.props;
        return location.pathname === '/settings/' + this.props.url ? true : false;
    }
}

export default withRouter(connect()(ListItem));



// WEBPACK FOOTER //
// ./src/components/settings/SettingsListItem.js